import { render } from "./UploadNewFileOverlay.vue?vue&type=template&id=ef1363c8"
import script from "./UploadNewFileOverlay.vue?vue&type=script&lang=js"
export * from "./UploadNewFileOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__